import { DataVizContainerViewConfigWithStateManager } from '../../../common/types';
import {
  TimePeriodUnsegmentedVizData,
  TimePeriodUnsegmentedVizExternalProps,
} from '../../types';
import { timePeriodUnsegmentedPieChartDataToUiComponentProps } from './dataToUiComponentProps';
import {
  TimePeriodUnsegmentedPieChartActions,
  TimePeriodUnsegmentedPieChartState,
  TimePeriodUnsegmentedPieChartUiComponentProps,
} from './types';
import { TimePeriodUnsegmentedPieChartUiComponent } from './UiComponent';
import { useTimePeriodUnsegmentedPieChartStateManager } from './useStateManager';

export const timePeriodUnsegmentedPieChartViewConfig: DataVizContainerViewConfigWithStateManager<
  TimePeriodUnsegmentedVizData,
  TimePeriodUnsegmentedVizExternalProps,
  TimePeriodUnsegmentedPieChartUiComponentProps,
  TimePeriodUnsegmentedPieChartState,
  TimePeriodUnsegmentedPieChartActions
> = {
  hasStateManager: true,
  useStateManager: useTimePeriodUnsegmentedPieChartStateManager,
  dataToUiComponentProps: timePeriodUnsegmentedPieChartDataToUiComponentProps,
  UiComponent: TimePeriodUnsegmentedPieChartUiComponent,
};
